import { Search } from '@mui/icons-material';
import { Box, Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { StyledVoiceDrawerToolbar } from './index.styled';

import LanguageSlider from './LanguageSlider';

const FILTER_VOICES = {
  ALL: 'all',
  MALE: 'male',
  FEMALE: 'female',
};

const VoiceDrawerToolbar = ({
  isSMSUser,
  openSearchPanel,
  setOpenSearchPanel,
  setPage,
  search,
  setSearch,
  // setVoices,
  setHasMore,
  selectedGender,
  setSelectedGender,
}) => {
  const { t, i18n } = useTranslation();
  const { languages } = useSelector((state) => state.language);
  const { language } = i18n;
  const dispatch = useDispatch();
  const { filterVoice } = useSelector((state) => state.voice);

  const languageDefault =
    language === 'vi'
      ? languages.find((lang) => lang.value === 'vi-VN')
      : languages.find((lang) => lang.value === 'en-US');

  const [currentLanguage, setCurrentLanguage] = useState(
    languages.find((lang) => lang.value === filterVoice.languageCode) ||
      languageDefault,
  );
  const [openLanguageBar, setOpenLanguageBar] = useState(false);

  const handleOpenSearchInput = () => {
    setSearch('');
    setHasMore(true);
    setOpenLanguageBar(false);
    setPage(1);
    setOpenSearchPanel(!openSearchPanel);
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleClickFilter = (chosen) => {
    setPage(1);
    setHasMore(true);
    setSelectedGender(chosen);
  };

  const handleClickLanguageButton = () => {
    setOpenLanguageBar(!openLanguageBar);
  };

  const handleChangeLanguage = (item) => {
    setPage(1);
    setHasMore(true);
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        languageCode: item.value,
      }),
    );
    setCurrentLanguage(item);
  };

  const renderStyleGender = (item) => {
    switch (item) {
      case FILTER_VOICES.ALL:
        return 'all';
      case FILTER_VOICES.MALE:
        return 'male';
      case FILTER_VOICES.FEMALE:
        return 'female';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (search.length === 0) {
      setHasMore(true);
      setPage(1);
    }
  }, [search]);

  useEffect(() => {
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        languageCode: currentLanguage.value,
      }),
    );
  }, []);

  return (
    <StyledVoiceDrawerToolbar>
      <div className="voice-drawer-toolbar-row">
        <IconButton
          color="secondary"
          onClick={handleOpenSearchInput}
          classes={{ root: 'icon-button' }}
          className="search-button"
        >
          {!openSearchPanel ? (
            <Search className="icon" />
          ) : (
            <KeyboardArrowLeftRoundedIcon className="icon" />
          )}
        </IconButton>
        {openSearchPanel ? (
          <div className="search-panel">
            <input
              className="search-input"
              placeholder={t('search')}
              onChange={handleChangeSearch}
            />
            <IconButton
              color="secondary"
              onClick={handleOpenSearchInput}
              classes={{ root: 'icon-button' }}
              className="clear-icon"
            >
              <ClearRoundedIcon />
            </IconButton>
          </div>
        ) : (
          <>
            <Box className="gender-box-button">
              {Object.values(FILTER_VOICES).map((value) => (
                <Button
                  key={value}
                  className={`gender-button ${renderStyleGender(value)} ${
                    selectedGender === value ? 'selected' : ''
                  }`}
                  onClick={() => handleClickFilter(value)}
                >
                  {t(value).charAt(0).toUpperCase() + t(value).slice(1)}
                </Button>
              ))}
            </Box>
            {!isSMSUser && (
              <button
                className="language-box-button"
                type="button"
                onClick={handleClickLanguageButton}
              >
                <img
                  className="img-flag"
                  src={currentLanguage.roundImage}
                  alt=""
                />
                {!openLanguageBar ? (
                  <KeyboardArrowRightRoundedIcon className="arrow-icon" />
                ) : (
                  <KeyboardArrowDownRoundedIcon className="arrow-icon" />
                )}
              </button>
            )}
          </>
        )}
      </div>
      {!isSMSUser && openLanguageBar && (
        <LanguageSlider
          onChangeLanguage={handleChangeLanguage}
          currentLanguageValue={currentLanguage.value}
        />
      )}
    </StyledVoiceDrawerToolbar>
  );
};

export default VoiceDrawerToolbar;
